import { AuthGuardEcm } from '@alfresco/adf-core';
import { Route } from '@angular/router';
import { EnterpriseViewerTab } from './components/EnterpriseViewer/enterprise-viewer-tab.component ';
import { ViewInTabComponent } from './components/view-in-tab/view-in-tab.component';

export const jobdocumentsRoutes: Route[] = [
  /* {path: '', pathMatch: 'full', component: InsertYourComponentHere} */
  {
    path: 'aev/preview/:id',
    component: EnterpriseViewerTab,
    canActivate: [AuthGuardEcm],
    data: {
    }
  },
  {
    path: 'view/tab/:parentId/:id',
    component: ViewInTabComponent,
    canActivate: [AuthGuardEcm],
    data: {
    }
  },
];
